import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=e0dbdb3c&scoped=true&"
import script from "./Books.vue?vue&type=script&lang=js&"
export * from "./Books.vue?vue&type=script&lang=js&"
import style0 from "./Books.vue?vue&type=style&index=0&id=e0dbdb3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dbdb3c",
  null
  
)

export default component.exports